import { axiosInstance } from "../axiosInstance";
const getBeginnerBonusList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`_agency/beginner_bonus`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const updateBeginnerBonus = (data) => axiosInstance.post(`_agency/beginner_bonus`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})

const deleteBeginnerBonus = (data) => axiosInstance.post(`_agency/beginner_bonus_delete`, data)

const getTypeOfMonths = () => axiosInstance.get(`_agency/type_of_months`).then(res => res?.data)
const updateTypeOfMonths = (data) => axiosInstance.post(`_agency/type_of_months`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
const deleteTypeOfMonths = (data) => axiosInstance.post(`_agency/type_of_months_delete`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
const updateStatusTypeOfMonths = (data) => axiosInstance.post(`_agency/type_of_months_status_update`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})

const getAdvanceBonusList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`_agency/advanced_bonus`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const updateAdvanceBonus = (data) => axiosInstance.post(`_agency/advanced_bonus`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})

const deleteAdvanceBonus = (data) => axiosInstance.post(`_agency/advanced_bonus_delete`, data)

const getAllTypeOfMonths = () => axiosInstance.get(`_agency/get-type-of-months`).then(res => res?.data)

const getBonus = ({ page,
    per_page = 1,
    delay = 1,
    search, ...params }) => axiosInstance.get(`_agency/bonus`, {
        params: {
            page,
            per_page,
            delay,
            search,
            ...params
        }
    }).then(res => res?.data)

const deleteBonus = (data) => axiosInstance.post(`_agency/bonus/delete`, data)
const generateBonus = (data) => axiosInstance.post(`_agency/bonus/generate_bonus`, data)

export { getBeginnerBonusList, updateBeginnerBonus, deleteBeginnerBonus, getTypeOfMonths, updateTypeOfMonths, deleteTypeOfMonths, updateStatusTypeOfMonths, getAllTypeOfMonths, getAdvanceBonusList, updateAdvanceBonus, deleteAdvanceBonus, getBonus, deleteBonus, generateBonus }
